module.exports = __webpack_public_path__ + "static/media/20170806_47day_2266AT.28c6b6bc.jpg";